import { useState } from "react";
import { Modal } from "antd";
import { Provider, useStore, useDispatch, useSelector } from "react-redux";
import WordingTemplateAutoComplete from "~/components/app/WordingTemplateAutoComplete";
import { rejectPost } from "~/redux/actions/post";

const useRejectPost = () => {
  const store = useStore();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user.token);

  const showRejectPostModal = (postId, callback) => {
    let reason = null;
    let templateId = null;

    Modal.confirm({
      title: "确认拒绝帖子？",
      width: 560,
      content: (
        <Provider store={store}>
          <WordingTemplateAutoComplete
            style={{ width: "100%" }}
            scenario="reject_post"
            onChange={(value) => {
              reason = value;
            }}
            onSelectTemplate={(option) => {
              templateId = option.id;
            }}
            placeholder="拒绝原因（选填）"
          />
        </Provider>
      ),
      onOk() {
        dispatch(
          rejectPost(
            token,
            postId,
            {
              reason,
              reason_template_id: templateId,
            },
            (success) => {
              callback && callback(success);
            }
          )
        );
      },
      onCancel() {
        callback && callback(false);
      },
    });
  };

  return { showRejectPostModal };
};

export default useRejectPost;
